<template>
  <section class="history-section-container">
    <div class="content-wrapper">
      <div class="title">
        <h2>történelem</h2>
        <div id="underline"></div>
      </div>
      <div class="subtext">
        <p>
          A fokos több mint 4600 éves múltra tekint vissza. Európába először a szkíták révén került, majd a későbbi idők folyamán a kontinenst végigportyázó magyaroknál is feltűnt, ahol végül az első világháborúig használatban maradt a csatatereken.
          <br><br>
          A fokos kialakítása az idők során folyamatosan alkalmazkodott az ellenfelek védelméhez, páncélzatához, hiszen a hosszú története során számos ellenféllel került szembe kezdve a hoplitáktól a kataphraktokon, a középkori lovagokon és janicsárokon át egészen a modern sorkatonákig.
        </p>
      </div>
      <div id="separator"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HistorySection",
}
</script>

<style scoped>
.history-section-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #FFFFFF;
  padding-bottom: 5%;
  padding-top: 5%;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1400px;
}

h2 {
  font-size: 64px;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 1.1;
}

#underline {
  background: #EFBE3E;
  height: 6px;
  width: 100%;
  border-radius: 10px;
}

#separator {
  background: #C4C4C4;
  height: 1px;
  width: 85%;
  margin-top: 5%;
}

.subtext {
  margin-top: 7vh;
  width: 60%;
  font-size: 18px;
  line-height: 200%;
}

@media only screen and (max-width: 1200px) {
  #separator {
    display: none;
  }
}

@media only screen and (max-width: 900px) {
  h2 {
    margin-top: 25px;
    font-size: 48px;
  }

  .subtext {
    width: 100%;
    padding: 0 7%;
    margin-top: 40px;
  }
}

@media only screen and (max-width: 600px) {
  h2 {
    font-size: 34px;
  }
}

</style>
